import { render, staticRenderFns } from "./PeriodEndWrapper.vue?vue&type=template&id=476988c2"
import script from "./PeriodEndWrapper.vue?vue&type=script&lang=js"
export * from "./PeriodEndWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476988c2')) {
      api.createRecord('476988c2', component.options)
    } else {
      api.reload('476988c2', component.options)
    }
    module.hot.accept("./PeriodEndWrapper.vue?vue&type=template&id=476988c2", function () {
      api.rerender('476988c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/periodEnd/PeriodEndWrapper.vue"
export default component.exports